import React from 'react';

import CountrySection from './CountrySection';

const CountrySections = ({ sections }) => {
    const sectionsContent = sections.map((section) => (
        <CountrySection section={section} key={section.title} />
    ));
    return <div>{sectionsContent}</div>;
};

export default CountrySections;
